<template>
  <div>
    <table class="table table-sm color mb-2">
      <caption class="caption table-caption">CIRT Specification</caption>
      <tbody>
        <!-- <tr>
          <th class="text-left font-weight-normal">Retention (%)</th>
          <td class="text-right">
            <b-form-input id="retention" v-model="retention" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>  -->
        <tr>
          <th class="text-left font-weight-normal">Initial Limit ($)</th>
          <td class="text-right">
            <b-form-input id="ownedFaceAmt" v-model="ownedFaceAmt" class="calculation-settings-input" :formatter="formatUSD" lazy-formatter></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Collateral (%)</th>
          <td class="text-right">
            <b-form-input id="margin" v-model="margin" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Interest Rate (%)</th>
          <td class="text-right">
            <b-form-input id="interest" v-model="interestRate" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>
        <!-- <tr>
          <th class="text-left font-weight-normal">Target Collateral (%)</th>
          <td class="text-right">
            <b-form-input id="marginTarget" v-model="marginTarget" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Annual Premium (%)</th>
          <td class="text-right">
            <b-form-input id="annualPremium" v-model="annualPremium" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Premium Capture</th>
          <td class="text-right">
            <b-form-group class="mb-0 text-left">
              <b-form-radio-group v-model="isPremiumCapture" :options="[{ text: 'True', value: true }, { text: 'Flase', value: false }]">
              </b-form-radio-group>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Mos Btwn Resets</th>
          <td class="text-right">
            <b-form-input id="regReset" type="number" v-model="regReset" class="calculation-settings-input"></b-form-input>
          </td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>

<script>
import formatter from "../../utilities/Formatter";

export default {
  props: ["inputOwnedFaceAmt", "inputMargin", "inputInterestRate"], //, "inputOwnedFaceAmt", "inputRetention", "inputMarginTarget", "inputAnnualPremium", "inputIsPremiumCapture", "inputRegReset"],
  computed: {
    ownedFaceAmt: {
      get: function () {
        return this.inputOwnedFaceAmt;
      },
      set: function (newVal) {
        this.$emit("ownedFaceAmtChange", newVal)
      }
    },
    margin: {
      get: function () {
        return this.inputMargin;
      },
      set: function (newVal) {
        this.$emit("marginChange", newVal)
      }
    },
    interestRate: {
      get: function () {
        return this.inputInterestRate;
      },
      set: function (newVal) {
        this.$emit("interestRateChange", newVal)
      }
    }
    // ownedFaceAmt: {
    //   get: function () {
    //     return this.inputOwnedFaceAmt;
    //   },
    //   set: function (newVal) {
    //     this.$emit("ownedFaceAmtChange", newVal)
    //   }
    // },
    // retention: {
    //   get: function () {
    //     return this.inputRetention;
    //   },
    //   set: function (newVal) {
    //     this.$emit("retentionChange", newVal)
    //   }
    // },
    // marginTarget: {
    //   get: function () {
    //     return this.inputMarginTarget;
    //   },
    //   set: function (newVal) {
    //     this.$emit("marginTargetChange", newVal)
    //   }
    // },
    // annualPremium: {
    //   get: function () {
    //     return this.inputAnnualPremium;
    //   },
    //   set: function (newVal) {
    //     this.$emit("annualPremiumChange", newVal)
    //   }
    // },
    // isPremiumCapture: {
    //   get: function () {
    //     return this.inputIsPremiumCapture;
    //   },
    //   set: function (newVal) {
    //     this.$emit("isPremiumCaptureChange", newVal)
    //   }
    // },
    // regReset: {
    //   get: function () {
    //     return this.inputRegReset;
    //   },
    //   set: function (newVal) {
    //     this.$emit("regResetChange", newVal)
    //   }
    // },
  },
  methods: {
    formatUSD: function(val, event) {
      return formatter.formatDollarValue(val)
    }
  }
}
</script>